export default "__VITE_ASSET__DojhxW4d__"